import { z } from 'zod'
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi'

// Patch `z.ZodType.prototype.openapi` once, at shared load time, so every
// schema in this package can be registered with the OpenAPI generator (in
// @rapid-response/api) regardless of import order. Imported first by ./index.ts.
extendZodWithOpenApi(z)
